import {
	FormControlLabel,
	FormGroup,
	makeStyles,
	Switch,
	Tab,
	Tabs,
	TextField,
	withStyles,
} from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import PlacesAutocomplete, {
	geocodeByAddress,
	getLatLng,
} from 'react-places-autocomplete';
import * as PROJECT_CODE from '../../constants/projectCode';
import { FirebaseContext } from '../../context/firebase';
import { updateDocumentOnly } from '../../api/Clients/updateDocumentOnly.api';

function CoBrokerForm({
	setShowDocInfo,
	addItemDocModal,
	setAddItemDocModal,
	clientJson,
	setLoading,
}) {
	const { firebase } = useContext(FirebaseContext);
	const [address, setAddress] = useState('');

	const [formData, setFormData] = useState({
		salesAgency: '',
		agentName: '',
		agentEmail: '',
		phoneNumber: '',
		commission: '',
	});

	const { salesAgency, agentName, agentEmail, phoneNumber, commission } =
		formData;

	const onChange = (e) =>
		setFormData({ ...formData, [e.target.name]: e.target.value });

	const useStyles = makeStyles((theme) => ({
		root: {
			flexGrow: 1,
			borderRadius: 8,
		},
		form: {
			display: 'flex',
			flexDirection: 'column',
		},
		field: {
			marginBottom: '20px',
			width: '100%',
			margin: '20px',
			'& .MuiInput-underline:after': {
				borderBottomColor: 'blue',
				borderBottom: '2px solid',
			},
		},
	}));

	const styles = useStyles();

	const handleSave = () => {
		var coBrokerDetails = {
			salesAgency: salesAgency,
			address: address,
			agentName: agentName,
			agentEmail: agentEmail,
			phoneNumber: phoneNumber,
			commission: commission,
		};
		updateDocumentOnly(
			clientJson?.salesAgentPointer,
			clientJson?.keyValue,
			'coBrokerDetails',
			coBrokerDetails
		);
		setShowDocInfo(false);
		setAddItemDocModal({
			...addItemDocModal,
			coBroker: false,
		});
		setLoading(true);
	};

	const handleSelect = async (value) => {
		setAddress(value);
	};

	return (
		<div className='lawyer_wrapper'>
			<div className={styles.root}>
				<div className='lawyer_form'>
					<div className={styles.form}>
						<TextField
							type='text'
							label='Sales Agency'
							name='salesAgency'
							value={salesAgency}
							className={styles.field}
							onChange={(e) => onChange(e)}
						/>

						<PlacesAutocomplete
							value={address}
							onChange={setAddress}
							onSelect={handleSelect}
							className={styles.field}
						>
							{({
								getInputProps,
								suggestions,
								getSuggestionItemProps,
								loading,
							}) => (
								<div className={styles.field}>
									<TextField
										style={{ width: '100%' }}
										{...getInputProps({
											placeholder: 'Address',
											className: 'location-search-input',
										})}
									/>

									<div className='autocomplete-dropdown-container'>
										{loading && <div>Loading...</div>}
										{suggestions.map((suggestion) => {
											const className = suggestion.active
												? 'suggestion-item--active'
												: 'suggestion-item';
											// inline style for demonstration purpose
											const style = suggestion.active
												? {
														backgroundColor:
															'#fafafa',
														cursor: 'pointer',
												  }
												: {
														backgroundColor:
															'#ffffff',
														cursor: 'pointer',
												  };
											return (
												<div
													{...getSuggestionItemProps(
														suggestion,
														{
															className,
															style,
														}
													)}
												>
													<span>
														{suggestion.description}
													</span>
												</div>
											);
										})}
									</div>
								</div>
							)}
						</PlacesAutocomplete>

						<TextField
							type='text'
							label='Agent Name'
							name='agentName'
							value={agentName}
							className={styles.field}
							onChange={(e) => onChange(e)}
						/>
						<TextField
							type='email'
							label='Email Address'
							name='agentEmail'
							value={agentEmail}
							autoComplete='false'
							className={styles.field}
							onChange={(e) => onChange(e)}
						/>

						<TextField
							type='tel'
							label='Phone Number'
							className={styles.field}
							pattern='[0-9]{3}[0-9]{3}[0-9]{4}'
							name='phoneNumber'
							value={phoneNumber}
							onChange={(e) => onChange(e)}
						/>

						<TextField
							type='number'
							label='Commission (%)'
							name='commission'
							value={2}
							autoComplete='false'
							disabled
							className={styles.field}
							onChange={(e) => onChange(e)}
						/>
					</div>
					<button
						className='corporationBtn btn btn-primary d-block mr-0 ml-auto'
						onClick={() => handleSave()}
					>
						Save
					</button>
				</div>
			</div>
		</div>
	);
}

export default CoBrokerForm;
